import React from 'react';
import Hero from './Hero';
import Team from './Team';
import Sidebar from './Sidebar';

function ShopDetail({ shop, user, onNavigate, darkMode }) {
  if (!shop) return (
    <div style={{ padding: '50px', textAlign: 'center', color: darkMode ? 'white' : 'black' }}>
      Shop not found. <button onClick={() => onNavigate('home')} className="premium-login-btn">Go Back</button>
    </div>
  );

  return (
    <div style={{ background: darkMode ? '#0f172a' : '#f8fafc', minHeight: '100vh', paddingBottom: '60px', color: darkMode ? 'white' : '#0f172a' }}>
      
      {/* Top Navbar */}
      <nav style={{ background: darkMode ? '#1e293b' : 'white', padding: '15px 40px', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 100, display: 'flex', alignItems: 'center' }}>
        <button 
          onClick={() => onNavigate('home')} 
          className="premium-login-btn" 
          style={{ background: darkMode ? '#334155' : '#f1f5f9', color: darkMode ? 'white' : '#0f172a', border: 'none', boxShadow: 'none' }}
        >
          ← Back to Search
        </button>
      </nav>

      {/* Main Content Area */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* Banner, Title, and Reviews */}
        <Hero shop={shop} user={user} />

        {/* Layout: Team (Left) & Map/Hours (Right) */}
        <div style={{ display: 'flex', gap: '40px', marginTop: '30px', flexWrap: 'wrap' }}>
          
          <div style={{ flex: '2', minWidth: '320px' }}>
            <Team isOpen={true} shop={shop} />
          </div>

          <div style={{ flex: '1', minWidth: '300px' }}>
            <Sidebar isOpen={true} shop={shop} />
          </div>

        </div>
      </div>
    </div>
  );
}

export default ShopDetail;